import { Injectable } from '@angular/core';
import { MenuFilter, Theme, ThemeStateService } from 'ats-ui-lib';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { PoMenuItem } from '@po-ui/ng-components';

@Injectable()
export class MenuFilterService implements MenuFilter {
  constructor(private themeService: ThemeStateService) {}

  filter(flatMenuItems: PoMenuItem[]): Observable<PoMenuItem[]> {
    return of(flatMenuItems);
  }

  transform(menuItems: PoMenuItem[]): Observable<PoMenuItem[]> {
    const addThemeToLinks = (menuItem: PoMenuItem, currentTheme: Theme | undefined): PoMenuItem => {
      return <PoMenuItem>{
        ...menuItem,
        link: menuItem.link?.startsWith('http') ? menuItem.link : `/main/${menuItem.link}`,
        subItems: menuItem.subItems?.map((subItem) => addThemeToLinks(subItem, currentTheme)),
      };
    };
    return this.themeService.currentTheme$.pipe(
      map((currentTheme) => {
        return menuItems.map((menuItem) => addThemeToLinks(menuItem, currentTheme));
      }),
    );
  }
}
